import { tw } from "../../styling";
import { SvgIcon } from "../svg-icon";

type Props = {
	step: number;
	isCompleted: boolean;
	isDisabled: boolean;
};

// eslint-disable-next-line tailwindcss/no-arbitrary-value
const baseStyle = tw`border-interactive-primary bg-interactive-primary text-text-contrast tablet:left-[-32px] relative left-[-16px] flex h-[32px] max-w-[32px] min-w-[32px] items-center justify-center rounded-full border border-solid`;

const disabledStyle = tw`bg-background-primary text-interactive-primary`;

const completedStyle = tw`border-foreground-success bg-background-success text-foreground-success`;

const StepLabel = ({ step, isCompleted, isDisabled }: Props) => {
	const classes = tw(baseStyle, isDisabled && disabledStyle, isCompleted && completedStyle);
	return <span className={classes}>{isCompleted ? <SvgIcon imageSrc="CHECK" /> : step}</span>;
};

export default StepLabel;
